export const OptInStatus = {
  ACCEPTED: 'accepted',
  NEW: 'new',
  UPDATED: 'updated'
};

export default OptInStatus;
